import { createSlice } from "@reduxjs/toolkit";
import { fetchInvoiceData, fechInvoiceSingleDataList, updateInvoiceGeneration, adminApproveInvoice, invoiceApproveList, fetchApproveInvoiceSingleList, financeApproveInvoice, sendInvoiceEmail, GenerateInvoiceProofUrl, updateInvoicePaymentDetails, generateLateFeeInvoice, getLateFeeInvoices, updateLateInvoicePaymentDetails, activateDeactivateVendorStatus, generateFrobinInvoice } from "../actions/FinancialManagementAction";
import { GenerateCandidateStatusCancelReport } from "../actions/AdminActions";
const fetchInvoiceDataSlice = createSlice({
  name: "fetchInvoiceData",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(fetchInvoiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});
const fechInvoiceSingleDataListSlice = createSlice({
  name: "fechInvoiceSingleDataList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fechInvoiceSingleDataList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fechInvoiceSingleDataList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(fechInvoiceSingleDataList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const updateInvoiceGenerationSlice = createSlice({
  name: "updateInvoiceGeneration",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateInvoiceGeneration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInvoiceGeneration.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(updateInvoiceGeneration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminApproveInvoiceSlice = createSlice({
  name: "adminApproveInvoice",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminApproveInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminApproveInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminApproveInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});




const invoiceApproveListSlice = createSlice({
    name: "adminApproveInvoice",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(invoiceApproveList.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(invoiceApproveList.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(invoiceApproveList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  const fetchApproveInvoiceSingleListSlice = createSlice({
    name: "adminApproveInvoice",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchApproveInvoiceSingleList.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchApproveInvoiceSingleList.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(fetchApproveInvoiceSingleList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  const financeApproveInvoiceSlice = createSlice({
    name: "financeApproveInvoice",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(financeApproveInvoice.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(financeApproveInvoice.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(financeApproveInvoice.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  const sendInvoiceEmailSlice = createSlice({
    name: "sendInvoiceEmail",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(sendInvoiceEmail.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(sendInvoiceEmail.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(sendInvoiceEmail.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  // const GenerateInvoiceProofUrlSlice = createSlice({
  //   name: "GenerateInvoiceProofUrl",
  //   initialState: {
  //     loading: false,
  //     data: null,
  //     error: null,
  //   },
  //   reducers: {},
  //   extraReducers: (builder) => {
  //     builder
  //       .addCase(GenerateInvoiceProofUrl.pending, (state) => {
  //         state.loading = true;
  //         state.error = null;
  //       })
  //       .addCase(GenerateInvoiceProofUrl.fulfilled, (state, action) => {
  //         state.loading = false;
  //         state.data = action.payload;
  //         // Call the success callback if provided
  //         if (typeof action.meta.arg.successFn === "function") {
  //           action.meta.arg.successFn(action.payload);
  //           console.log("action page", action.payload);
  //         }
  //       })
  //       .addCase(GenerateInvoiceProofUrl.rejected, (state, action) => {
  //         state.loading = false;
  //         state.error = action.error.message;
  //         // Call the failure callback if provided
  //         if (typeof action.meta.arg.failureFn === "function") {
  //           action.meta.arg.failureFn(action.error.message);
  //           console.log("action:::", action.error.message);
  //         }
  //       });
  //   },
  // });

 const GenerateInvoiceProofUrlSlice = createSlice({
    name: "GenerateInvoiceProofUrl",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(GenerateInvoiceProofUrl.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(GenerateInvoiceProofUrl.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(GenerateInvoiceProofUrl.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });

  const updateInvoicePaymentDetailsSlice = createSlice({
    name: "updateInvoicePaymentDetails",
    initialState: {
      loading: false,
      data: null,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(updateInvoicePaymentDetails.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateInvoicePaymentDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          // Call the success callback if provided
          if (typeof action.meta.arg.successFn === "function") {
            action.meta.arg.successFn(action.payload);
            console.log("action page", action.payload);
          }
        })
        .addCase(updateInvoicePaymentDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          // Call the failure callback if provided
          if (typeof action.meta.arg.failureFn === "function") {
            action.meta.arg.failureFn(action.error.message);
            console.log("action:::", action.error.message);
          }
        });
    },
  });
  

const createLateFeeSlice = (name, thunk) =>
  createSlice({
    name,
    initialState: { loading: false, data: null, error: null },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
          if (typeof action.meta.arg.successFn === "function") {
            const cb = action.meta.arg.successFn;
            const payload = action.payload;
            setTimeout(() => cb(payload), 0);
          }
        })
        .addCase(thunk.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          if (typeof action.meta.arg.failureFn === "function") {
            const cb = action.meta.arg.failureFn;
            const msg = action.error.message;
            setTimeout(() => cb(msg), 0);
          }
        });
    },
  });

export const reducers = {
  fetchInvoiceData: fetchInvoiceDataSlice.reducer,
  fechInvoiceSingleDataList: fechInvoiceSingleDataListSlice.reducer,
  updateInvoiceGeneration: updateInvoiceGenerationSlice.reducer,
  adminApproveInvoice:adminApproveInvoiceSlice.reducer,
  invoiceApproveList:invoiceApproveListSlice.reducer,
  fetchApproveInvoiceSingleList:fetchApproveInvoiceSingleListSlice.reducer,
  financeApproveInvoice:financeApproveInvoiceSlice.reducer,
  sendInvoiceEmail:sendInvoiceEmailSlice.reducer,
  GenerateInvoiceProofUrl:GenerateInvoiceProofUrlSlice.reducer,
  updateInvoicePaymentDetails:updateInvoicePaymentDetailsSlice.reducer,
  generateLateFeeInvoice: createLateFeeSlice("generateLateFeeInvoice", generateLateFeeInvoice).reducer,
  getLateFeeInvoices: createLateFeeSlice("getLateFeeInvoices", getLateFeeInvoices).reducer,
  updateLateInvoicePaymentDetails: createLateFeeSlice("updateLateInvoicePaymentDetails", updateLateInvoicePaymentDetails).reducer,
  activateDeactivateVendorStatus: createLateFeeSlice("activateDeactivateVendorStatus", activateDeactivateVendorStatus).reducer,
  generateFrobinInvoice: createLateFeeSlice("generateFrobinInvoice", generateFrobinInvoice).reducer,
};


